import React from "react";
import Slider from "react-slick";
import Head from "next/head";
import Img1 from "../assets/images/contact-images/1.jpg";


const SimpleSlider = () => {

    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    };
    return (
        <>
            <Head>
                <link
                    rel="stylesheet"
                    type="text/css"
                    charSet="UTF-8"
                    href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
                />
            </Head>
            <Slider {...settings}>
                <div>
                    <img
                        src={Img1.src}
                        alt=""
                    />
                </div>
            </Slider>
        </>
    );
}

export default SimpleSlider;
